import { Helmet } from "react-helmet";
import { BiPlus } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import Layout from "Components/Layout/index";
import CommonClasses from "Styles/Common.module.css";
import Categories from "./categories";
function Tutor() {
    const Navigate = useNavigate();
    return (
        <Layout Active={"Categories"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Gift Categories</title>
            </Helmet>
            <div className={CommonClasses["Container"]}>
            <div>
                    <h1 style={{ color: '#FF0D0D' }}>GIFT CATEGORIES</h1>
                </div>
                <div className={CommonClasses["control-btns"]}>
                    <button
                        className={CommonClasses["button"]}
                        onClick={() => {
                            Navigate("/categories/add");
                        }}>
                        <BiPlus size={20} /> Create New Category
                    </button>
                </div>
                <div className={CommonClasses["wrapper"]}>
                    <Categories />
                </div>
            </div>
        </Layout>
    );
}

export default Tutor;
